import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { deleteBranch } from "@tCentro/Services/CENAdminBranchService";

export interface DeleteBranchParameter extends HasOnSuccess<void>, HasOnError<string> {
    branchId: string;
}

type HandlerType = ApiHandler<DeleteBranchParameter, {}>;

export const DeleteBranch: HandlerType = async props => {
    try {
        await deleteBranch(props.parameter.branchId); // ← no result, just await
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(); // ← called with no argument
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to delete branch");
        }
    }
};

export const chain = [DeleteBranch];
const deleteBranchData = createHandlerChainRunner(chain, "deleteBranchData");
export default deleteBranchData;
